import Swal from 'sweetalert2/dist/sweetalert2.js';
function fireSwal (message, status) {
    Swal.fire({
        title: message,
        position: 'top-end',
        customClass: {
            container: 'custom-swal-container',
        },
        toast: true,
        icon: status,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        },
        showCloseButton: true,
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 3000,

    })
}
export default fireSwal
